import React from "react";

const IconColorDescription = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 27 27">
      <g
        id="Group_1463"
        dataname="Group 1463"
        transform="translate(-1058 -524)"
      >
        <circle
          id="Ellipse_227"
          dataname="Ellipse 227"
          cx="13.5"
          cy="13.5"
          r="13.5"
          transform="translate(1058 524)"
          fill="#ffe6cc"
        />
        <g
          id="Group_1460"
          dataname="Group 1460"
          transform="translate(1032.314 29.017)"
        >
          <rect
            id="Rectangle_1128"
            dataname="Rectangle 1128"
            width="13.218"
            height="2.997"
            transform="translate(32.686 502.983)"
            fill="none"
            stroke="#fa933f"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.7"
          />
          <g
            id="Group_1458"
            dataname="Group 1458"
            transform="translate(32.921 508.158)"
          >
            <line
              id="Line_116"
              dataname="Line 116"
              x2="7.96"
              transform="translate(0 0)"
              fill="none"
              stroke="#fa933f"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.7"
            />
            <line
              id="Line_117"
              dataname="Line 117"
              x2="7.96"
              transform="translate(0 1.755)"
              fill="none"
              stroke="#fa933f"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.7"
            />
          </g>
          <g
            id="Group_1461"
            dataname="Group 1461"
            transform="translate(32.921 512.158)"
          >
            <line
              id="Line_116-2"
              dataname="Line 116"
              x2="7.96"
              transform="translate(0 0)"
              fill="none"
              stroke="#fa933f"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.7"
            />
            <line
              id="Line_117-2"
              dataname="Line 117"
              x2="7.96"
              transform="translate(0 1.755)"
              fill="none"
              stroke="#fa933f"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="0.7"
            />
          </g>
          <circle
            id="Ellipse_228"
            dataname="Ellipse 228"
            cx="1.229"
            cy="1.229"
            r="1.229"
            transform="translate(43.209 507.807)"
            fill="none"
            stroke="#fa933f"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.7"
          />
          <circle
            id="Ellipse_229"
            dataname="Ellipse 229"
            cx="1.229"
            cy="1.229"
            r="1.229"
            transform="translate(43.209 511.807)"
            fill="none"
            stroke="#fa933f"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.7"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconColorDescription;
